module.exports = __webpack_public_path__ + "assets/img/vtuber-ads5.3cc34195.png";